module.exports = __webpack_public_path__ + "static/work24-f9e957a8c6f88c1d2a033d41dda7f636.jpg";